import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { ConfigProvider } from 'antd';

import './bv-application-layout.scss';

import localeEn from 'antd/lib/locale/en_US';
import localeIt from 'antd/lib/locale/it_IT';
import 'moment/locale/it';

const BVApplicationLayout: React.FunctionComponent = (props) => {
    const [locale, setLocale] = useState(localeEn);

    const _handleLocale = () => {
        let currentLocale = navigator.language;
        if (currentLocale.indexOf('it') > -1) {
            setLocale(localeIt);
            moment.locale('it');
        }
        if (currentLocale.indexOf('en') > -1) {
            setLocale(localeEn);
            moment.locale('en');
        }
    }

    useEffect(() => {
        _handleLocale();
    });

    return (
        <ConfigProvider locale={locale} csp={{ nonce: 'r9180709826544b9d9c31807aaf89900b' }}>
            {props.children}
        </ConfigProvider>
    );
}

export default BVApplicationLayout;